import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import Pane from 'components/Common/Pane'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import TextButton from 'LuxKit/Button/TextButton'
import { CHARTER_PAGE_SLUG } from 'constants/charterFlight'
import LayoutContainer from 'components/Common/LayoutContainer'
import LoyaltyRewardsIcon from 'LuxKit/Icons/loyalty/LoyaltyRewardsIcon'
import LoyaltyRewardsIntroTable from './LoyaltyRewardsIntroTable'

const DescriptionWrapper = styled.div`
  max-width: ${rem(700)};
  text-align: start;

  @media (min-width: 704px) {
    text-align: center;
  }
`

const TableBreakpoint = styled(CSSBreakpoint)`
  width: 100%;
  min-width: 0;
`

function LoyaltyRewardsIntroSection() {
  const intl = useIntl()

  const heading = intl.formatMessage({
    id: 'z4ovsskTtzRMITgkM7jA',
    defaultMessage: 'What are Société Rewards?',
    description: 'Section heading explaining what Société Rewards are on the rewards landing page',
  })

  const description = intl.formatMessage({
    id: 'EIYnP1XzhLtCkKmHDv9a',
    defaultMessage: 'Société Rewards Seats are a limited allocation on our direct Maldives charter flights, exclusively reserved for Société members. Redeem your points for the flight, then pay for taxes and fees and your choice of hotel package. At the highest-value redemption rate that beats paying full price, it’s the ultimate way to spend your Points. To book, look for the green Société Rewards badge when searching flights.',
    description: 'Introductory description explaining Société Rewards on the rewards landing page',
  })

  const browseBundlesLabel = intl.formatMessage({
    id: 'D3vBJ4Gmluk4fjflklMZ',
    defaultMessage: 'Browse Maldives Bundles',
    description: 'Primary call-to-action button in the Société rewards page intro section',
  })

  return (
    <Pane padding="48 0">
      <Group direction="vertical" gap={28} horizontalAlign="center">
        <LayoutContainer variant="medium">
          <Group direction="vertical" gap={16} horizontalAlign="center">
            <LoyaltyRewardsIcon size={52} colour="highlight-primary-dark" />
            <Heading variant="heading2" as="h2">{heading}</Heading>
            <DescriptionWrapper>
              <BodyText variant="medium">{description}</BodyText>
            </DescriptionWrapper>
          </Group>
        </LayoutContainer>
        <TableBreakpoint min="tablet">
          <LayoutContainer variant="medium">
            <LoyaltyRewardsIntroTable />
          </LayoutContainer>
        </TableBreakpoint>
        <TableBreakpoint max="mobile">
          <LoyaltyRewardsIntroTable />
        </TableBreakpoint>
        <LayoutContainer variant="medium">
          <Group direction="horizontal" horizontalAlign="center">
            <TextButton kind="primary" size="large" to={`/campaign/${CHARTER_PAGE_SLUG}`}>
              {browseBundlesLabel}
            </TextButton>
          </Group>
        </LayoutContainer>
      </Group>
    </Pane>
  )
}

export default LoyaltyRewardsIntroSection
